import JoinRequestIcon from '@material-ui/icons/PersonAdd';

import JoinRequestList from './JoinRequestList';

export default {
    list: JoinRequestList,
    icon: JoinRequestIcon,
};
